import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _styled from "styled-components";
import React, { useState } from "react";
import { ReactComponent as IconMinus } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/minuscircleblue.svg";
import { ReactComponent as IconPlus } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/pluscircleblue.svg";
import { ReactComponent as SuccessIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/success.svg";
import { ModalScreen } from "../ModalScreen/ModalScreen";
import { KeyboardFrame } from "../Keyboard/Num/KeyboardFrame";
import { formatDecimalNumber } from "./utils";
var iconButtonSize = 50;

var StyledModalScreen = _styled(ModalScreen).withConfig({
  displayName: "NumberInputModal__StyledModalScreen",
  componentId: "sc-1wi6vei-0"
})(["background-color:white;"]);

var Container = _styled.div.withConfig({
  displayName: "NumberInputModal__Container",
  componentId: "sc-1wi6vei-1"
})(["flex:1;display:flex;flex-direction:column;height:100%;"]);

var Description = _styled.div.withConfig({
  displayName: "NumberInputModal__Description",
  componentId: "sc-1wi6vei-2"
})(["text-align:center;margin-top:60px;font-size:24px;"]);

var SubDescription = _styled.div.withConfig({
  displayName: "NumberInputModal__SubDescription",
  componentId: "sc-1wi6vei-3"
})(["text-align:center;font-size:20px;"]);

var ValueContainer = _styled.div.withConfig({
  displayName: "NumberInputModal__ValueContainer",
  componentId: "sc-1wi6vei-4"
})(["flex:1;display:flex;align-items:center;justify-content:center;font-size:24px;"]);

var IconButton = _styled.button.withConfig({
  displayName: "NumberInputModal__IconButton",
  componentId: "sc-1wi6vei-5"
})(["background:none transparent;border:0 none;padding:0;display:inline-block;&:focus{outline:0 none;}svg{display:block;}"]);

var Value = _styled.div.withConfig({
  displayName: "NumberInputModal__Value",
  componentId: "sc-1wi6vei-6"
})(["min-width:200px;text-align:center;color:", ";"], function (p) {
  return p.error ? "red" : "inherit";
});

export function NumberInputModal(_ref) {
  var isOpen = _ref.isOpen,
      initialValue = _ref.initialValue,
      unit = _ref.unit,
      onClose = _ref.onClose,
      onDone = _ref.onDone,
      title = _ref.title,
      incrementable = _ref.incrementable,
      minValue = _ref.minValue,
      maxValue = _ref.maxValue,
      decimals = _ref.decimals;

  var _useState = useState("".concat(initialValue)),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var numValue = +value;
  var isOverMin = numValue < minValue;
  var isOverMax = numValue > maxValue;
  var isValid = !isOverMin && !isOverMax;
  var decrementDisabled = isOverMin || numValue === minValue;
  var incrementDisabled = isOverMax || numValue === maxValue;

  var setNumValue = function setNumValue(num) {
    setValue("".concat(num));
  };

  var handleNumChange = function handleNumChange(newValue) {
    var match = newValue.match(/^(-?)0*(\d{0,6})/);
    setValue(!match ? "" : "".concat(match[1]).concat(match[2]));
  };

  var handleDecrementClick = function handleDecrementClick() {
    setNumValue(isOverMax ? maxValue : numValue - 1);
  };

  var handleIncrementClick = function handleIncrementClick() {
    setNumValue(isOverMin ? minValue : numValue + 1);
  };

  var handleConfirmAction = function handleConfirmAction() {
    if (isValid) {
      onDone(numValue);
    }
  };

  return /*#__PURE__*/React.createElement(StyledModalScreen, {
    isOpen: isOpen,
    onClose: onClose,
    onAction: handleConfirmAction,
    actionIcon: isValid ? SuccessIcon : undefined
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Description, null, title), /*#__PURE__*/React.createElement(SubDescription, null, "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D: ", formatDecimalNumber(minValue, decimals), " -", " ", formatDecimalNumber(maxValue, decimals)), /*#__PURE__*/React.createElement(ValueContainer, null, incrementable && /*#__PURE__*/React.createElement(IconButton, {
    onClick: !decrementDisabled ? handleDecrementClick : undefined
  }, /*#__PURE__*/React.createElement(IconMinus, {
    fillOpacity: decrementDisabled ? 0.5 : 1,
    height: iconButtonSize,
    width: iconButtonSize
  })), /*#__PURE__*/React.createElement(Value, {
    error: !isValid
  }, formatDecimalNumber(numValue, decimals), unit ? " ".concat(unit) : undefined), incrementable && /*#__PURE__*/React.createElement(IconButton, {
    onClick: !incrementDisabled ? handleIncrementClick : undefined
  }, /*#__PURE__*/React.createElement(IconPlus, {
    fillOpacity: incrementDisabled ? 0.5 : 1,
    height: iconButtonSize,
    width: iconButtonSize
  }))), /*#__PURE__*/React.createElement(KeyboardFrame, {
    value: value,
    onChange: handleNumChange,
    disableMinus: minValue >= 0
  })));
}